import { render } from "./WorkflowfolgeclientfunktionenDetailsKonfiguration.pug?vue&type=template&id=3ff93b0f&lang=pug"
import script from "./WorkflowfolgeclientfunktionenDetailsKonfiguration.js?vue&type=script&lang=js"
export * from "./WorkflowfolgeclientfunktionenDetailsKonfiguration.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__